import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import './styles/global.css';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Home from './pages/Home';
import WealthManagement from './pages/WealthManagement';
import RiskManagement from './pages/RiskManagement';
import Finance from './pages/Finance';
import About from './pages/About';
import ScheduleMeeting from "./pages/ScheduleMeeting";
import Contact from './pages/Contact';
import ServiceDetail from './pages/ServiceDetail';
import Blogs from './pages/Blogs';
import TermsConditions from './pages/TermsConditions';
import PrivacyPolicy from './pages/PrivacyPolicy';
import Gallery from './pages/Gallery';
import BlogDetail from './pages/BlogDetail';
import Admin from './pages/Admin';

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo({ top: 0, behavior: 'smooth' }); }, [pathname]);
  return null;
}

function AppRoutes() {
  return (
    <>
      <ScrollToTop />
      <Navbar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/wealth-management" element={<WealthManagement />} />
        <Route path="/risk-management" element={<RiskManagement />} />
        <Route path="/finance-management" element={<Finance />} />
        <Route path="/finance" element={<Finance />} />
        <Route path="/schedule-meeting" element={<ScheduleMeeting />} />
        <Route path="/blogs" element={<Blogs />} />
        <Route path="/blog/:id" element={<BlogDetail />} />
        <Route path="/admin" element={<Admin />} />
        <Route path="/terms-conditions" element={<TermsConditions />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/about" element={<About />} />
        <Route path="/gallery" element={<Gallery />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/service/:type/:id" element={<ServiceDetail />} />
        <Route path="*" element={<Home />} />
      </Routes>
      <Footer />
    </>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AppRoutes />
    </BrowserRouter>
  );
}
